<h3 class="sidebar-title">Menu</h3>
<mat-nav-list class="sidebar-items fxlayout-column">
    @if (canViewBudget) {
        <a mat-list-item routerLink="/opportunities">
            <mat-icon matListIcon>bookmarks</mat-icon>
            <span class="menu-label" i18n>Opportunity</span>
        </a>
    }
    @if (canViewBudget) {
        <a mat-list-item routerLink="/budget">
            <mat-icon matListIcon>attach_money</mat-icon>
            <span class="menu-label" i18n>Budget</span>
        </a>
    }
    @if (canViewInternalProjects) {
        <a mat-list-item routerLink="/internalproject">
            <mat-icon matListIcon>attach_money</mat-icon>
            <span class="menu-label" i18n="Application to manage internal project">Internal Projects</span>
        </a>
    }
    @if (canViewOrder) {
        <a mat-list-item routerLink="/order">
            <mat-icon matListIcon>local_shipping</mat-icon>
            <span class="menu-label" i18n>Orders</span>
        </a>
    }
    @if (canViewInvoices) {
        <a mat-list-item routerLink="/invoices">
            <mat-icon matListIcon>receipt</mat-icon>
            <span class="menu-label" i18n>Invoices</span>
        </a>
    }
    @if ((canViewInvoices || canViewInvoicesCosmo) && cosmoEnabled) {
        <a mat-list-item routerLink="/invoices-cosmo">
            <mat-icon matListIcon>receipt</mat-icon>
            <span class="menu-label" i18n>Cosmo Invoices</span>
        </a>
    }
    @if (canViewInvoices) {
        <a mat-list-item routerLink="/ddt">
            <mat-icon matListIcon>receipt</mat-icon>
            <span class="menu-label" i18n>Delivery Notes</span>
        </a>
    }
    @if (canViewTimeReport) {
        <a mat-list-item routerLink="/timereport">
            <mat-icon matListIcon>access_time</mat-icon>
            <span class="menu-label" i18n="Activity time reports link">Time Report</span>
        </a>
    }
    @if (canViewStatCollector) {
        <a mat-list-item routerLink="/reportactivities">
            <mat-icon matListIcon>analytics</mat-icon>
            <span class="menu-label" i18n="Activity time reports link">Report Activities</span>
        </a>
    }
    @if (canViewLaserCut) {
        <a mat-list-item routerLink="/lasercut">
            <mat-icon matListIcon>flash_on</mat-icon>
            <span class="menu-label" i18n="Lase Cut Interface">Laser Cut</span>
        </a>
    }
    @if (canViewUsers) {
        <a mat-list-item routerLink="/users">
            <mat-icon matListIcon>group</mat-icon>
            <span class="menu-label" i18n="Lase Cut Interface">Users</span>
        </a>
    }
    @if (canViewBalanceOverview) {
        <a mat-list-item routerLink="/workSummary">
            <mat-icon matListIcon>people_outline</mat-icon>
            <span class="menu-label" i18n="Work hours">Work Summary</span>
        </a>
    }
    @if (canViewUsers && userRole === 'admin') {
        <a mat-list-item routerLink="/superadmin">
            <mat-icon matListIcon>security</mat-icon>
            <span class="menu-label" i18n>Super Admin</span>
        </a>
    }
    @if (canViewAdmin) {
        <a mat-list-item routerLink="/admin">
            <mat-icon matListIcon>security</mat-icon>
            <span class="menu-label" i18n>Admin</span>
        </a>
    }
</mat-nav-list>